import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { faArrowUp,faArrowRight} from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-coins',
  encapsulation:ViewEncapsulation.None,
  templateUrl: './coins.component.html',
  styleUrls: ['./coins.component.scss']
})
export class CoinsComponent implements OnInit {
  faArrUp=faArrowUp;
  faLArrR=faArrowRight;
  constructor(
  ) { }

  ngOnInit(): void {
  
  }



}
